export function extractActivoConfigs(raw) {
    if (typeof raw === 'string') {
        try { raw = JSON.parse(raw); } catch { return []; }
    }
    if (!raw || typeof raw !== 'object') return [];
    if (!Array.isArray(raw) && ['base_producto_id', 'group_prefix', 'enabled'].some(key => Object.hasOwn(raw, key))) return [raw];
    return Object.values(raw).filter(value => value && typeof value === 'object' && !Array.isArray(value));
}

export function isCatalogGroup(field) {
    return field?.type === 'group' && field.field_type === 'subgroup'
        && Array.isArray(field.subgroup_items) && field.subgroup_items.length > 0;
}

export function activoConfigsForGroup(template, field) {
    if (!template || !isCatalogGroup(field)) return [];
    const local = Object.hasOwn(field, 'activo_config');
    const hasSource = Object.hasOwn(field, '_source_template_activo_config');
    const raw = local ? field.activo_config : hasSource ? field._source_template_activo_config
        : !template.id || template._is_combined || String(template.id).startsWith('combined_') ? [] : template.activo_config;
    const siblings = (template.fields || []).filter(candidate => isCatalogGroup(candidate) && (!hasSource
        || (field._template_id != null ? candidate._template_id === field._template_id
            : field._source_index != null && candidate._source_index === field._source_index)));
    const prefix = String(field.prefix || '').trim();
    return extractActivoConfigs(raw).filter(config => {
        if (Object.hasOwn(config, 'enabled') && ![true, 1, '1', 'true'].includes(config.enabled)) return false;
        const family = Number(config.base_producto_id);
        const configPrefix = String(config.group_prefix || '').trim();
        return Number.isSafeInteger(family) && family > 0
            && (configPrefix ? configPrefix === prefix : local || siblings.length === 1);
    });
}

export function collectCompatibleBaseProductoIdsByGroup(template, field) {
    return new Set(activoConfigsForGroup(template, field).map(config => Number(config.base_producto_id)));
}

export function resolveCompatibleGroupIdxForActivo(template, activo, preferredGroupIdx = null) {
    const family = Number(activo?.base_producto_id);
    if (!Number.isSafeInteger(family) || family <= 0) return null;
    const candidates = Object.entries(template?.fields || []);
    return candidates.find(([index, field]) => (preferredGroupIdx == null || index === String(preferredGroupIdx))
        && collectCompatibleBaseProductoIdsByGroup(template, field).has(family))?.[0] ?? null;
}
